//initialize
var modelInitializer = new ModelInitializer();
var CommentsModel = modelInitializer.Get("CommentsModel");

var bookmarkStatus = true;

window.copyToClipBoard = function (id) {
  var copyText = id;
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  document.execCommand("copy");
}

// add topic to bookmark
window.bookmarkTopicItem = function (element, type, id) {
  bookmarkStatus = element.classList.contains("is-bookmarked") ? false : true;
  itemBookmark(element, type, id, bookmarkStatus);
}

//copy from url link
window.copyLink = function (id) {
  var dummy = document.createElement("input"),
    text = window.location.href;

  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
}

//map in blog 
function loadMap() {
  var coordinate = [];

  var maps = document.getElementsByClassName('map');

  for (var i = 0; i < maps.length; i++) {

    var meta = maps[i].getElementsByTagName("span");

    maps[i].id = 'map' + i;

    for (var index = 0; index < meta.length; index++) {

      if (meta[index].getAttribute("itemprop") === 'latitude') {

        coordinate[0] = meta[index].getAttribute('data');

      } else if (meta[index].getAttribute("itemprop") === 'longitude') {

        coordinate[1] = meta[index].getAttribute('data');

      }
    }

    var map = L.map('map' + i).setView(coordinate, 14, {
      reset: true
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a rel="nofollow" href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>',
      subdomains: 'abcd'
    }).addTo(map);

    L.marker(coordinate).addTo(map);
    L.control.fullscreen({
      position: 'bottomleft',
      forceSeparateButton: true,
      forcePseudoFullscreen: true,
      fullscreenElement: true
    }).addTo(map);
  };
}

$(function () {
  //moment En
  moment.locale("en");

  //  Initialize Comments Plugin
  if (masterViewModel) {
    if (masterViewModel.commentViewModel) {
      masterViewModel.commentViewModel.initialize({
        sendcomment: CommentsModel.sendcomment,
        secodnswaitforsending: CommentsModel.secodnswaitforsending,
        topicId: CommentsModel.topicId,
        commentLength: CommentsModel.commentLength,
        timeBetweenAddComments: CommentsModel.timeBetweenAddComments,
        remainingTimeToEditComment: CommentsModel.remainingTimeToEditComment,
        defaultAvatarPath: CommentsModel.defaultAvatarPath,
        prefixAvatarPath: CommentsModel.prefixAvatarPath,
        isUserAuthenticated: CommentsModel.isUserAuthenticated,
        isAdmin: CommentsModel.isAdmin,
        isAuthor: CommentsModel.isAuthor,
        isReadOnlyEnabled: CommentsModel.isReadOnlyEnabled,
        loadUrl: CommentsModel.loadUrl,
        addUrl: CommentsModel.addUrl,
        editUrl: CommentsModel.editUrl,
        replyUrl: CommentsModel.replyUrl,
        reportUrl: CommentsModel.reportUrl,
        voteUrl: CommentsModel.voteUrl,
        unPublishUrl: CommentsModel.unPublishUrl,
        deleteUrl: CommentsModel.deleteUrl,
        blockIpUrl: CommentsModel.blockIpUrl,
        blockUserUrl: CommentsModel.blockUserUrl,
        infoMessageType: CommentsModel.infoMessageType,
        warningMessageType: CommentsModel.warningMessageType,
        successMessageType: CommentsModel.successMessageType,
        errorMessageType: CommentsModel.errorMessageType,

        sortOptions: [
          { text: CommentsModel.sortOptions[0].text, value: 1, isSelected: true },
          {
            text: CommentsModel.sortOptions[1].text,
            value: 2,
            isSelected: false,
          },
          {
            text: CommentsModel.sortOptions[2].text,
            value: 4,
            isSelected: false,
          },
          {
            text: CommentsModel.sortOptions[3].text,
            value: 8,
            isSelected: false,
          },
        ],
      });

      masterViewModel.commentViewModel.loadComments();
    }
  }

  //scroll to comment form
  $("body").delegate(".js-add-comment", "click", function () {
    $("html, body").animate(
      {
        scrollTop: $(".js-comment-form").offset().top,
      },
      800
    );
  });

  // sticky side bar
  $(".js-sticky-side-bar").theiaStickySidebar({
    additionalMarginTop: 16,
  });

  //light gallery
  $(".lightgallery, .demo-gallery").lightGallery({
    thumbnail: true,
  });

  //comment-show in mobile
  $(".js-btn-toggle-comment").click(function () {
    $(this).next(".js-blog-comment").toggle();

    $(this).hide();
  });

  //TopicUrl
  var url = window.location.href;
  $("#shareLink").val(url);
  
  // check topic is bookmarked
  if (CommentsModel.isUserAuthenticated) {
    $.ajax({
      url: "/Utility/Favorite/isFavorit",
      data: {
        EntityRef: Number(CommentsModel.topicId),
        EntityType: Number(CommentsModel.EntityType),
      },
      type: "Post",
    }).done(function (response) {
      if (response.model.exist) {
        $(".js-bookmark-btn").addClass("is-bookmarked");
        bookmarkStatus = false;
      }
    });
  }

  loadMap();
});